import {
  SET_CART_DETAIL,
  SET_CATEGORIES,
  SET_SUB_CATEGORIES,
  SET_PRODUCTS,
  SET_PRODUCT_DETAIL,
  SET_STORE_DETAIL,
  SET_SHIPPING_CHARGES,
  SET_ORDER_DETAIL,
  SET_PAYMENT_INFO,
  SET_RECENT_ORDER,
  SET_ZONEWISE_DELIVERYCHARGES,
  SET_SEARCH_RESULTS,
  SET_BIRDBUCK_COUPON,
  SET_TAXES,
  SET_STORE_LOCATIONS,
  SET_USER_SHIPPING_ZONE_INFO,
  SET_SUBSCRIPTIONS,
  SET_SUBSCRIPTIONS_DETAIL,
  SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL,
  SET_SUBSCRIBABLE_PRODUCTS,
  SET_SUBSCRIPTION_CONFIG,
  SET_DISCOUNT_COUPON,
  SET_PROMO_IMAGE,
  SET_STORE_FEATURE,
  SET_BIRDBUCKS_BY_USER,
  SET_STORE_DISCOUNT_MAP,
  SET_REFERRAL_PRODUCTS,
  SET_ORDER_POINTS,
  SET_GIFT_CARDS,
  SET_ERPLY_BIRDBUCKS_BY_USER
  
} from './action-types';

export function setCartDetail(data) {
  return {
    type: SET_CART_DETAIL,
    data
  };
}
export function setAvailableSubscriptionsInterval(data) {
  return {
    type: SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL,
    data
  };
}
export function  setSubscriptions(data) {
  return {
    type: SET_SUBSCRIPTIONS,
    data
  };
}

export function setCategories(data) {
  return {
    type: SET_CATEGORIES,
    data
  };
}

export function setSubCategories(data) {
  return {
    type: SET_SUB_CATEGORIES,
    data
  };
}

export function setProducts(data) {
  return {
    type: SET_PRODUCTS,
    data
  };
}

export function setProductDetail(data) {
  return {
    type: SET_PRODUCT_DETAIL,
    data
  };
}
export function setStoreDetail(data) {
  return {
    type: SET_STORE_DETAIL,
    data
  };
}

export function setShippingCharges(data) {
  return {
    type: SET_SHIPPING_CHARGES,
    data
  };
}

export function setOrderDetail(data) {
  return {
    type: SET_ORDER_DETAIL,
    data
  };
}

export function setPaymentInfo(data) {
  return {
    type: SET_PAYMENT_INFO,
    data
  };
}

export function setRecentOrder(data) {
  return {
    type: SET_RECENT_ORDER,
    data
  };
}

export function setZoneWiseDeliveryCharges(data) {
  return {
    type: SET_ZONEWISE_DELIVERYCHARGES,
    data
  };
}

export function setSearchResults(data) {
  return {
    type: SET_SEARCH_RESULTS,
    data
  };
}

export function setBirdBuckCoupon(data) {
  return {
    type: SET_BIRDBUCK_COUPON,
    data
  };
}

export function setTaxes(data) {
  return {
    type: SET_TAXES,
    data
  };
}

export function setStoreLocations(data) {
  return {
    type: SET_STORE_LOCATIONS,
    data
  };
}
export function setUserShippingZoneInfo(data) {
  return {
    type: SET_USER_SHIPPING_ZONE_INFO,
    data
  };
}
export function setSubscriptionsDetail(data) {
  return {
    type: SET_SUBSCRIPTIONS_DETAIL,
    data
  };
}
export function setSubscribableProducts(data) {
  return {
    type: SET_SUBSCRIBABLE_PRODUCTS,
    data
  };
}
export function setSubscriptionConfig(data) {
  return {
    type: SET_SUBSCRIPTION_CONFIG,
    data
  };
}
export function setDiscountCoupon(data){
	return {
		type : SET_DISCOUNT_COUPON,
		data
  };
}
export function setPromoImage(data){
    return {
      type : SET_PROMO_IMAGE,
      data
    };
}
export function setStoreFeatures(data){
  return {
    type : SET_STORE_FEATURE,
    data
  };
}
export function setBirdBucksByUser(data) {
  return {
    type: SET_BIRDBUCKS_BY_USER,
    data
  };
}

export function setStoreDiscountMap(data) {
  return {
    type: SET_STORE_DISCOUNT_MAP,
    data
  };
}

export function setReferralProducts(data) {
  return {
    type: SET_REFERRAL_PRODUCTS,
    data
  };
}

export function setOrderPoints(data) {
  return {
    type: SET_ORDER_POINTS,
    data
  };
}

export function setGiftCards(data) {
    return {
      type: SET_GIFT_CARDS,
      data
    };
}

export function setErplyBirdBucksByUser(data) {
  return {
    type: SET_ERPLY_BIRDBUCKS_BY_USER,
    data
  };
}

export default {
  setCartDetail,
  setCategories,
  setSubCategories,
  setProducts,
  setProductDetail,
  setStoreDetail,
  setShippingCharges,
  setOrderDetail,
  setPaymentInfo,
  setRecentOrder,
  setZoneWiseDeliveryCharges,
  setSearchResults,
  setBirdBuckCoupon,
  setTaxes,
  setStoreLocations,
  setUserShippingZoneInfo,
  setSubscriptions,
  setSubscriptionsDetail,
  setAvailableSubscriptionsInterval,
  setSubscribableProducts,
  setSubscriptionConfig,
  setDiscountCoupon,
  setPromoImage,
  setStoreFeatures,
  setBirdBucksByUser,
  setStoreDiscountMap,
  setReferralProducts,
  setOrderPoints,
  setGiftCards,
  setErplyBirdBucksByUser
};



// WEBPACK FOOTER //
// ./src/app/order/actions.js